<template >
  <div class = "container" ref = "container" >
    <!-- <Header /> -->

    <van-nav-bar fixed placeholder title = "八点秒得" left-arrow @click-left = "$router.back()" />
  <van-popup v-model = "showSubmitPopup" :close-on-click-overlay = "false" class = "my_popup" >
      <div class = "close" >
       <van-icon name = "cross" @click = "close" />
    </div >
    <div class = "time-wrap" >
                <span >下单倒计时：</span >
                <van-count-down :time = "timeout" format = "mm 分 ss 秒" />
            </div >
     <div class = "form" >
                <div class = "item" >
                    <div class = "label" >联系人姓名</div >
                    <div class = "input" >
                        <van-field v-model = "receiverName" placeholder = "请输入联系人姓名" />
                    </div >
                </div >
        <div class = "item" >
                    <div class = "label" >联系人手机号</div >
                    <div class = "input" >
                        <van-field v-model = "phone" type = "tel" maxlength = "11" placeholder = "请输入联系人手机号" />
                    </div >
                </div >
         <div class = "btn-wrap" >

                    <div class = "btn" @click = "goPay" >
                        <span >提交订单</span >
                    </div >
                </div >
     </div >
    </van-popup >
    <Banner />

    <div class = "main-wrap" >
      <div class = "main-title" >今日推荐</div >

      <div class = "main-banner" >
        <van-swipe :autoplay = "5000" indicator-color = "#ff991d" >
          <van-swipe-item v-for = "(image, index) in bannerList" :key = "index" >
            <img v-lazy = "image" />
          </van-swipe-item >
        </van-swipe >
      </div >

      <div class = "main-info" >
        <div class = "info-name" >
          {{ goodsInfo.goodsName }}
        </div >
        <div class = "info-price" >
          <span >￥{{ goodsInfo.price }} </span >
          <span > / 张</span >
        </div >
      </div >

      <!-- <div class="main-select">
        <div class="select-item">
          <span class="label">规格</span>
          <span class="label">{{ goodsInfo.specStr }}</span>
        </div>
      </div> -->

      <div class = "btns" >
        <div class = "btn grey" v-if = "!isTimeOver" >
          <!-- <span>距离抢购开始</span> -->
          <van-count-down
              :time = "countDownTime"
              format = "HH 时 mm 分 ss 秒"
              @finish = "onCountDownFinish"
              :auto-start = "isStart"
          />
        </div >

        <div
            class = "btn"
            v-if = "isTimeOver && !isFinish && !isEmpty && !isGet"
            @click = "onRushBuy"
        >
          立即抢购
        </div >
        <div
            class = "btn"
            v-if = "isTimeOver && isGet && !isPayed"
            @click = "onOrderPay"
        >
          您有一笔订单暂未支付
        </div >
        <div class = "btn grey" v-if = "isTimeOver && isFinish" >活动已结束</div >
        <div class = "btn grey" v-if = "isTimeOver && isEmpty" >已抢光</div >
      </div >

      <div class = "main-goods" >
        <div class = "goods-text" v-html = "goodsInfo.content" ></div >
      </div >
    </div >
    <!-- <GoodsVirtual /> -->
    <Footer :goodsInfo = "goodsInfo" />
  </div >
</template >

<script >
import axios from "axios";
import { debounce } from "lodash";
import Header from "./components/Header";
import Banner from "./components/Banner";
// import GoodsVirtual from "./components/GoodsVirtual";
import Footer from "./components/Footer.vue";
import {
  doSecKill,
  getSecOrderInfo,
  getRecordList,
  getStartTime,
  getGoodsInfo,
  getConfirmVirtualOrder,
    getGoodsInfoList
} from "@/api/virtual";
import { cancelOrder } from "@/api/home";
import { loaclSetUserInfo, localGetUserInfo } from "@/utils/storage";
// ;

export default {
  name: "Home",
  components: {
    Header,
    Banner,
    Footer,

    // GoodsVirtual,
  },

  data () {
    return {
      timeout: 0,
      receiverName: localGetUserInfo ( "receiverName" ),
      phone: localGetUserInfo ( "phone" ),
      showSubmitPopup: false,
      scrollTop: 0,
      goodsDetail: {},
      goodsInfo: {},
      bannerList: [],
      timer: null,
      isTimeOver: false,
      isEmpty: false,
      isPayed: false,
      isFinish: false,

      isGet: false,

      countDownTime: 86399000,
      isStart: false,
      allowToPay: true,
      city: "",
    };
  },

  methods: {
    //两个虚拟商品详情
    async getGoodsInfoList(goodId){
      const {data:res} = await getGoodsInfoList(goodId)
      if(res.code===200){
        this.goodsInfo = res.data[0];
        this.bannerList = res.data[0].bannerList.split ( "|" )||[];
        this.$store.commit ( "setPayLimit", res.data[0].limit );

      }
    },
    onCountDownFinish () {
      this.isTimeOver = true;
    },

    onRushBuy () {
      this.doSecKill ();
    },

    onOrderPay () {
      this.$router.replace ( "/order" );
    },

    async doSecKill () {
      this.$toast.loading ( {
        duration: 0,
        message: "抢购中...",
      } );

      let secKillUrl = process.env.VUE_APP_ROB_URL;

      axios
          .post ( secKillUrl + "/secKill/doVirtualSecKill", {
            m2oId: this.$store.state.nthUserInfo.userid,
            token: this.$store.state.token,
            deviceToken: this.$store.state.deviceToken,
          } )
          .then ( ( res ) => {
            console.log ( res.data );
            if ( res.data.code == 200 ) {
              this.$toast.clear ();
              this.createTimer ();
            } else {
              if ( res.data.code == 200100 ) {
                this.isEmpty = true;
              }

              if ( res.data.code == 200102 ) {
                this.isFinish = true;
              }
              return this.$toast.fail ( res.data.msg );
            }
          } )
          .catch ( ( err ) => {
            this.$toast.clear ();
            if ( err.request.status == 429 ) {
              this.$toast.clear ();
            }
          } );

    },

    async getStartTime () {
      const { data: res } = await getStartTime ();

      console.log ( res, "虚拟" );
      if ( res.code == 200 ) {
        let date = res.data.replace ( /-/g, "/" );
        // let date = '2022-04-30 20:00:00'.replace(/-/g, "/");
        this.countDownTime = Date.parse ( new Date ( date ) ) - new Date ().getTime ();
        this.isStart = true;
      }
    },

    async getGoodsInfo () {
      const { data: res } = await getGoodsInfo ();
      if ( res.code == 200 ) {
        this.goodsInfo = res.data;
        this.bannerList = res.data.bannerList.split ( "|" )||[];
        this.$store.commit ( "setPayLimit", res.data.limit );

      }

      console.log ( res, "虚拟" );
    },

    async getSecOrderInfo () {
      const { data: res } = await getSecOrderInfo ( {
        m2oId: this.$store.state.nthUserInfo.userid,
      } );

      console.log ( "首次查询订单", res );
      if ( res.code == 200 ) {
        this.isGet = true;
      } else {
        if ( res.code == 200100 ) {
          this.isEmpty = true;
        }

        if ( res.code == 200005 ) {
          this.isPayed = true;
        }

        if ( res.code == 200102 ) {
          this.isFinish = true;
        }
      }
    },

    async goPay () {
      if ( !this.receiverName ) {
        return this.$toast.fail ( "请填写姓名" );
      } else if ( this.phone.length !== 11 ) {
        return this.$toast.fail ( "请输入正确的手机号" );
      }
      const params = {
        m2oId: this.$store.state.nthUserInfo.userid,
        orderId: this.orderId,
        phone: this.phone,
        receiverName: this.receiverName
      };

      const { data: res } = await getConfirmVirtualOrder ( params );
      if ( res.code === 200 ) {
        loaclSetUserInfo ( {
          receiverName: this.receiverName,
          phone: this.phone,
        } );
        if ( this.allowToPay ) {
          this.allowToPay = false;
          this.$router.push ( {
            path: "/pay",
            query: {
              data: JSON.stringify ( this.goodsDetail ),
            },
          } );
        }
      }

    },
    //轮询订单是否生成
    async getOrder () {
      const { data: res } = await getSecOrderInfo ( {
        m2oId: this.$store.state.nthUserInfo.userid,
      } );
      console.log ( "轮询订单", res );
      if ( res.code == 200 ) {
        this.timeout = res.data.timeout;
        this.orderId = res.data.id;
        this.goodsDetail = { ...res.data };
        this.$toast.clear ();
        // this.$toast.success("抢购成功");
        this.stopTimer ();
        this.showSubmitPopup = true;
      }
    },
    //取消订单
    async cancelOrder () {
      const { data: res } = await cancelOrder ( {
        m2oId: this.$store.state.nthUserInfo.userid,
        orderId: this.orderId,
      } );
      console.log ( res, "取消订单" );
      if ( res.code === 200 ) {
        this.$toast.fail ( "订单已取消" );
        this.popupShow = false;
      } else {
        this.popupShow = false;
      }
    },
    createTimer () {
      this.stopTimer ();
      this.timer = setInterval ( this.getOrder, 1000 );
      // this.getOrder()
    },
    stopTimer () {
      if ( this.timer ) {
        clearInterval ( this.timer );
        this.timer = null;
      }
    },

    init () {
      const isApp = SmartCity.isSmartCityApp ();
      if ( isApp ) {
        this.getNthUserInfo ();
      } else {
        if ( process.env.NODE_ENV === "development" ) {
          return;
        }
        // return this.$toast.fail("请在南太湖号App中打开！");
        this.$router.replace ( "/share" );
      }
    },
    close () {
      this.showSubmitPopup = false;
      this.cancelOrder ();
    },
    getNthUserInfo () {
      this.$toast.loading ( {
        duration: 0,
        message: "加载中...",
      } );
      SmartCity.getUserInfo ( ( res ) => {
        console.log ( res );
        if ( res && res.userInfo ) {
          this.$toast.clear ();
          this.$store.commit ( "setNthUserInfo", res.userInfo );
          this.$store.commit ( "setUserTokenKey", res.userInfo.userTokenKey );
          this.getSecOrderInfo ();

          SmartCity.getSystemInfo ( ( res2 ) => {
            console.log ( res2.deviceInfo.device_token, "dev" );

            this.$store.commit ( "setDeviceToken", res2.deviceInfo.device_token );
          } );
        } else {
          this.$toast.clear ();
          this.$dialog
              .alert ( {
                title: "提醒",
                message: "请先登录南太湖号",
              } )
              .then ( () => {
                SmartCity.goLogin ();
              } );
        }
      } );
    },
  },

  created () {
    const goodId = this.$route.query.goodId
    this.getStartTime ();
    this.$skillType === 4 ? this.getGoodsInfoList(goodId) : this.getGoodsInfo();
    if ( !this.$store.state.city ) {
      SmartCity.getLocation ( ( res ) => {
        console.log ( res );

        if ( res.city ) {
          this.$store.commit ( "setCity", res.city );
        }
      } );
    }

    if ( process.env.NODE_ENV === "development" ) {
      // this.init();

      // return;

      this.$store.commit ( "setUserTokenKey", "b819f6472575f02128c5bd851dbfda74" );
      this.$store.commit ( "setNthUserInfo", {
        userid: "1075",
      } );

      this.$store.commit ( "setDeviceToken", "res2.deviceInfo.device_token" );
      this.getSecOrderInfo ();
    } else {
      this.init ();
    }
  },
};
</script >
<style lang = "less" scoped >
.my_popup {
  width: 90%;
  border-radius: 4px;
  box-shadow: 0px 8px 19px #dedede;
  padding: 20px;
  max-height: 90%;

  .time-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ff991d;

    .van-count-down {
      color: #ff991d;
    }
  }

  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
    color: #c8c9cc;
    font-size: 22px;
    cursor: pointer;
  }

  .form {
    .item {
      display: flex;

      justify-content: space-between;
      align-items: center;

      .label {
        width: 70px;
        color: #666;

        // text-align: justify;
      }

      .input {
        /deep/ .van-field__control {
          display: block;
          box-sizing: border-box;
          width: 100%;
          min-width: 0;
          margin: 0;
          padding: 10px;
          color: #323233;
          line-height: inherit;
          text-align: left;
          background-color: #eee;
          border: 0;
          resize: none;
        }
      }

      .input {
        flex: 1;
      }
    }
  }

  .btn-wrap {
    display: flex;

    justify-content: space-between;
    align-items: center;

    .btn {
      width: 94%;
      line-height: 40px;
      background: #ff991d;
      border-radius: 20px;
      text-align: center;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 10px;
    }

    .btn-cancel {
      background: #fff;
      border-radius: 20px;
      border: 1px solid #ff991d;
      text-align: center;
      color: #ff991d;
    }
  }
}

.container {
  width: 100%;
  height: calc(100vh);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 40px;
  box-sizing: border-box;
  // background: chocolate;

  .swipe-wrap {
    height: calc(100vh - 310px);

    .van-swipe {
      height: 100%;
    }

    /deep/ .van-swipe__track--vertical {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
      // height: calc(100vh - 400px) !important;
    }

    /deep/ .van-swipe__track {
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      // height: calc(100vh - 400px) !important;
    }

    /deep/ .van-swipe-item {
      width: 100%;
      height: 100% !important;
      padding: 10px;
      overflow: hidden;
    }
  }

  .main-wrap {
    // z-index: 99;
    margin-top: -10px;
    // position: relative;
    background: #fff;
    border-radius: 10px;

    padding: 15px;
    // box-shadow: @shadow;

    .main-title {
      font-size: 16px;
      padding: 4px;

      color: #ff991d;
    }

    .main-banner {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;

      img {
        border-radius: 10px;
        width: 100%;
        //height: 100%;
        // border-radius: 4px;
      }
    }

    .main-info {
      margin-bottom: 10px;

      .info-name {
        font-size: 16px;
        padding: 4px;
      }

      .info-price {
        span:nth-child(1) {
          color: #ff991d;
          font-size: 20px;
        }

        span:nth-child(2) {
          color: #666;
        }
      }
    }

    .main-select {
      margin-bottom: 10px;
      background: #f9f9f9;
      padding: 10px;

      .select-item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          color: #666;
        }
      }
    }

    .btns {
      display: flex;
      /****按钮固定****/
      position: fixed;
      width: 98%;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index:2;
      /****按钮固定****/
      justify-content: center;
      align-items: center;

      .btn {
        width: 99%;
        height: 42px;

        text-align: center;
        padding: 10px 14px;
        border-radius: 20px;
        background: #ff7b07;
        color: #fff;

        display: flex;
        justify-content: center;
        align-items: center;

        .van-count-down {
          color: #fff;
        }
      }

      .grey {
        background: #ccc;
        color: #fff;
      }
    }

    .main-goods {
      .goods-text {
        /deep/ img {
          // border-radius: 10px;
          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        /deep/ video {
          // border-radius: 10px;
          margin-top: 10px;

          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        margin-bottom: 10px;

        /deep/ p {
          color: #666;

          line-height: 28px;

          // text-indent: 2em;
        }

        P {
          margin-block-start: 0;
          margin-block-end: 0;
          margin-inline-start: 0px;
          margin-inline-end: 0px;
        }
      }

      .goods-img {
        margin: 10px 0;

        img {
          // border-radius: 10px;
          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }

        video {
          // border-radius: 10px;
          margin-top: 10px;

          width: 100%;
          // height: 160px;
          // height: 214px;
          // border-radius: 4px;
        }
      }
    }

    .card-header {
      display: flex;

      justify-content: space-between;
      align-items: center;

      .ecard {
        padding: 4px 10px;
        border-radius: 10px 0 0 10px;
        background: #569aff;
        color: #fff;
        margin-right: -10px;
      }

      // flex-direction: column;
    }
  }
}

/deep/ .van-toast {
  z-index: 99999;
}

.grey {
  background: #eee;
}

.container::-webkit-scrollbar {
  display: none;
}
</style >
